import deviceIdService from './device';

/* 获取deviceId */
export const getDeviceId = async () => {
  try {
    return await deviceIdService.getEncryptedDeviceId();
  }
  catch (error) {
    return '';
  }
};
